var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconPng(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 68.5,
    height: 77.49,
    viewBox: "0 0 68.5 77.49",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4",
    "data-name": "Group 4",
    transform: "translate(-4542 -1004.75)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_31",
    "data-name": "Rectangle 31",
    width: 67.5,
    height: 76.49,
    rx: 15,
    transform: "translate(4542.5 1005.25)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    "data-name": "Path 3",
    d: "M14.072,4.4H9.158V17h1.8V13.184h3.114c3.276,0,5.256-1.656,5.256-4.392S17.348,4.4,14.072,4.4Zm-.054,7.218h-3.06V5.966h3.06c2.3,0,3.51,1.026,3.51,2.826S16.322,11.618,14.018,11.618ZM32.45,4.4v9.4L24.89,4.4H23.414V17h1.8V7.6l7.56,9.4H34.25V4.4ZM48.2,14.732a5.332,5.332,0,0,1-2.952.81,4.784,4.784,0,0,1-5-4.842,4.768,4.768,0,0,1,5.022-4.842A5,5,0,0,1,48.92,7.316L50.036,6.2a6.316,6.316,0,0,0-4.842-1.944,6.393,6.393,0,0,0-6.75,6.444,6.383,6.383,0,0,0,6.714,6.444,7.447,7.447,0,0,0,4.77-1.6V10.628H48.2Z",
    transform: "translate(4546.842 1011.439)",
    fill: "#3b57a9"
  }), /*#__PURE__*/React.createElement("image", {
    id: "image",
    width: 30,
    height: 24,
    transform: "translate(4561 1049)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAYCAYAAADtaU2/AAAABHNCSVQICAgIfAhkiAAAAUBJREFUSEvFVW0OwjAIde5Toz88j55DPaJ6Di9k4keMmRNiSdqGFrpM14SkG/AeUGiz9e44nXxXCYL7HOQJ0ppv1LXnw7bb7E+ZsUUb8nvDvga5g6AedZ3Z4zfqcRE27h8ZEKPRv1c5FvHUJqYy/jJ7qm4xFrFTak3Gdj9o7P3qkX9SqbkmTCVPJiaHJaRwA5mDXE06KeT9iGGWM5hl5CtAXhFiIvCDov+5trnIYQVkF5DGXBjIHQKn87X1hFOnEnOjxgH7dmRDxAstMQJJzSXdgEhONuI4acfHJ/Uz9CtQhTKORd/nTFXEUsnshgplahNxeDM/49A5aoLhOpwC8P2d5gp1ohQ9NzZc99vkziNhG8duI6m7Y68bO07ayGPAko6Im5Q5lkA1+tHf46RnUZORZMPeXJLTkHrn5hoSWMKqPsGdcQsJOXzzAAAAAElFTkSuQmCC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6",
    "data-name": "Path 6",
    d: "M10.937,23.322V22.8H7.973V27h.6V25.3h2.106v-.516H8.573V23.322Zm1.47-.114a.375.375,0,1,0-.39-.372A.377.377,0,0,0,12.407,23.208ZM12.119,27H12.7V23.82h-.576Zm2.154,0h.576V22.548h-.576ZM19.3,25.428a1.533,1.533,0,0,0-1.572-1.638,1.557,1.557,0,0,0-1.6,1.62,1.592,1.592,0,0,0,1.71,1.626A1.6,1.6,0,0,0,19.1,26.52l-.318-.372a1.187,1.187,0,0,1-.918.384,1.077,1.077,0,0,1-1.152-.93h2.58C19.3,25.548,19.3,25.476,19.3,25.428Zm-1.572-1.152a.992.992,0,0,1,1.02.912h-2.04A.991.991,0,0,1,17.729,24.276Zm8.04-1.476v3.132L23.249,22.8h-.492V27h.6V23.868L25.877,27h.492V22.8Zm3.414.99a2.118,2.118,0,0,0-1.314.408l.24.432a1.608,1.608,0,0,1,1.008-.342c.57,0,.852.282.852.768v.114h-.912c-.948,0-1.278.42-1.278.93,0,.552.456.936,1.176.936A1.18,1.18,0,0,0,30,26.58V27h.546V25.08C30.545,24.21,30.053,23.79,29.184,23.79Zm-.132,2.8c-.438,0-.7-.2-.7-.516,0-.27.162-.492.732-.492h.888v.444A.922.922,0,0,1,29.052,26.592Zm7.02-2.8a1.433,1.433,0,0,0-1.224.588,1.177,1.177,0,0,0-1.1-.588,1.289,1.289,0,0,0-1.1.5V23.82h-.552V27h.576V25.362a.923.923,0,0,1,.954-1.056c.522,0,.822.306.822.93V27h.576V25.362a.923.923,0,0,1,.954-1.056c.522,0,.822.306.822.93V27h.576V25.17A1.219,1.219,0,0,0,36.072,23.79Zm5.736,1.638a1.533,1.533,0,0,0-1.572-1.638,1.557,1.557,0,0,0-1.6,1.62A1.733,1.733,0,0,0,41.6,26.52l-.318-.372a1.187,1.187,0,0,1-.918.384,1.077,1.077,0,0,1-1.152-.93H41.8C41.8,25.548,41.808,25.476,41.808,25.428Zm-1.572-1.152a.992.992,0,0,1,1.02.912h-2.04A.991.991,0,0,1,40.236,24.276Z",
    transform: "translate(4551.026 1013.439)",
    fill: "#3b57a9"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPng);
export default __webpack_public_path__ + "static/media/iconPng.80ece8cc2f2beda8a057e025582ec7e2.svg";
export { ForwardRef as ReactComponent };